exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: diablo) {\n.textContent[data-v-70015f30] {\n    color: #a2a4a5;\n    font-weight: 400;\n}\n.btn-text[data-v-70015f30] {\n    color: #a2a4a5;\n}\n}", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-popover2/diablo.css"],"names":[],"mappings":";AAAA;AAEE;IACE,eAAe;IACf,iBAAiB;CAClB;AACD;IACE,eAAe;CAChB;CACF","file":"diablo.css","sourcesContent":["@media screen and (weex-theme: diablo) {\n  \n  .textContent {\n    color: #a2a4a5;\n    font-weight: 400;\n  }\n  .btn-text {\n    color: #a2a4a5;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70015f30","scoped":true,"hasInlineConfig":false}!./packages/dof-popover2/diablo.css
// module id = 219
// module chunks = 0 1